<template>
  <header
    class="site-header"
    :class="{
      'is-scrolled': isScrolled,
      'is-top': !isScrolled,
      'menu-open': mobileMenuOpen
    }"
  >
    <div class="header-container container">
      <!-- Logo -->
      <router-link to="/" class="logo" @click.native="closeMenu">
        <img class="logo-image" :src="logoImage" alt="Nivi" />
      </router-link>

      <!-- 桌面端导航 -->
      <nav class="nav-menu">
        <ul class="nav-list" v-if="navItems.length > 0">
          <template v-for="item in navItems">
            <li v-if="navChildren(item.id).length > 0" :key="'d-' + item.id" class="nav-item nav-dropdown" :class="{ active: isDropdownActive(item), 'is-open': desktopDropdownOpen }" @focusout="handleDesktopFocusout">
              <button type="button" class="nav-link nav-link-dropdown" aria-haspopup="true" :aria-expanded="String(desktopDropdownOpen)" @click="toggleDesktopDropdown" @keydown.esc="closeDesktopDropdown">
                {{ item.title }}
                <svg class="dropdown-arrow" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>
              <div class="dropdown-wrapper">
                <ul class="dropdown-menu">
                  <li v-for="child in navChildren(item.id)" :key="'dc-' + child.id" :class="{ active: isActive(child.url) }">
                    <router-link :to="child.url" class="dropdown-link">
                      <span class="dropdown-dot" aria-hidden="true"></span>
                      {{ child.title }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li v-else :key="'s-' + item.id" class="nav-item" :class="{ active: isActive(item.url) }">
              <router-link :to="item.url" class="nav-link" :exact="item.url === '/'">{{ item.title }}</router-link>
            </li>
          </template>
        </ul>
        <ul class="nav-list" v-else>
          <li class="nav-item" :class="{ active: isActive('/') }">
            <router-link to="/" class="nav-link" exact>首页</router-link>
          </li>
          <li class="nav-item nav-dropdown" :class="{ active: isActive('/products'), 'is-open': desktopDropdownOpen }" @focusout="handleDesktopFocusout">
            <button type="button" class="nav-link nav-link-dropdown" aria-haspopup="true" :aria-expanded="String(desktopDropdownOpen)" @click="toggleDesktopDropdown" @keydown.esc="closeDesktopDropdown">产品介绍<svg class="dropdown-arrow" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"></polyline></svg></button>
            <div class="dropdown-wrapper">
              <ul class="dropdown-menu">
                <li v-for="series in productSeries" :key="'df-' + series.id" :class="{ active: isActive(series.route) }">
                  <router-link :to="series.route" class="dropdown-link"><span class="dropdown-dot" aria-hidden="true"></span>{{ series.name }}</router-link>
                </li>
              </ul>
            </div>
          </li>
          <li class="nav-item" :class="{ active: isActive('/technology') }"><router-link to="/technology" class="nav-link">技术引擎</router-link></li>
          <li class="nav-item" :class="{ active: isActive('/about') }"><router-link to="/about" class="nav-link">关于我们</router-link></li>
          <li class="nav-item" :class="{ active: isActive('/news') }"><router-link to="/news" class="nav-link">新闻动态</router-link></li>
          <li class="nav-item" :class="{ active: isActive('/cooperation') }"><router-link to="/cooperation" class="nav-link">商务合作</router-link></li>
        </ul>
      </nav>

      <!-- 汉堡按钮 -->
      <button
        type="button"
        ref="menuButton"
        class="hamburger"
        :class="{ open: mobileMenuOpen }"
        @click.stop="toggleMenu"
        aria-label="菜单"
        :aria-expanded="String(mobileMenuOpen)"
        aria-controls="site-mobile-nav"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <!-- 遮罩层 -->
    <div
      v-show="mobileMenuOpen"
      class="menu-overlay"
      @click="closeMenu"
    ></div>

    <!-- 移动端抽屉菜单 -->
    <nav
      id="site-mobile-nav"
      ref="mobileNav"
      v-show="mobileMenuOpen"
      class="mobile-nav"
      aria-label="移动端导航"
    >
      <div class="mobile-nav-inner">
        <ul class="mobile-nav-list" v-if="navItems.length > 0">
          <template v-for="item in navItems">
            <li v-if="navChildren(item.id).length > 0" :key="'m-' + item.id" class="mobile-section-label">
              <span class="mobile-sub-title">{{ item.title }}</span>
            </li>
            <template v-if="navChildren(item.id).length > 0">
              <li v-for="child in navChildren(item.id)" :key="'mc-' + child.id" class="sub-item" :class="{ active: isActive(child.url) }">
                <router-link :to="child.url" @click.native="closeMenu">{{ child.title }}</router-link>
              </li>
            </template>
            <li v-else :key="'ms-' + item.id" :class="{ active: isActive(item.url) }">
              <router-link :to="item.url" @click.native="closeMenu" :exact="item.url === '/'">{{ item.title }}</router-link>
            </li>
          </template>
        </ul>
        <ul class="mobile-nav-list" v-else>
          <li :class="{ active: isActive('/') }"><router-link to="/" @click.native="closeMenu" exact>首页</router-link></li>
          <li class="mobile-section-label"><span class="mobile-sub-title">产品介绍</span></li>
          <li v-for="series in productSeries" :key="'mf-' + series.id" class="sub-item" :class="{ active: isActive(series.route) }">
            <router-link :to="series.route" @click.native="closeMenu">{{ series.name }}</router-link>
          </li>
          <li :class="{ active: isActive('/technology') }"><router-link to="/technology" @click.native="closeMenu">技术引擎</router-link></li>
          <li :class="{ active: isActive('/about') }"><router-link to="/about" @click.native="closeMenu">关于我们</router-link></li>
          <li :class="{ active: isActive('/news') }"><router-link to="/news" @click.native="closeMenu">新闻动态</router-link></li>
          <li :class="{ active: isActive('/cooperation') }"><router-link to="/cooperation" @click.native="closeMenu">商务合作</router-link></li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import logoImage from '@/assets/images/logo/nivi-logo.png'
import { productSeries } from '@/data/productCatalog'

const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
const CATALOG_PRODUCT_NAV_ID = 'catalog-products'

export default {
  name: 'SiteHeader',
  data() {
    return {
      isScrolled: false,
      mobileMenuOpen: false,
      desktopDropdownOpen: false,
      currentPath: '',
      mobileMenuReturnFocus: null,
      logoImage,
      productSeries
    }
  },
  computed: {
    ...mapGetters('button', ['navList']),
    navItems() {
      const items = this.sanitizedNavList.filter(item => !item.parentId || item.parentId === 0)
      if (items.length === 0 || items.some(item => item.id === this.productNavId)) return items

      const productItem = {
        id: CATALOG_PRODUCT_NAV_ID,
        parentId: 0,
        title: '产品介绍',
        url: '/products'
      }
      const homeIndex = items.findIndex(item => item.url === '/')
      items.splice(homeIndex >= 0 ? homeIndex + 1 : 0, 0, productItem)
      return items
    },
    navChildren() {
      const list = this.sanitizedNavList
      const productNavId = this.productNavId
      return function (parentId) {
        if (parentId === productNavId) {
          return productSeries.map(series => ({
            id: series.id,
            title: series.name,
            url: series.route,
            parentId
          }))
        }
        return list.filter(item => item.parentId === parentId)
      }
    },
    productNavId() {
      const productNav = (this.navList || []).find(item => (
        (!item.parentId || item.parentId === 0) &&
        (item.url === '/products' || item.title === '产品介绍')
      ))
      return productNav ? productNav.id : CATALOG_PRODUCT_NAV_ID
    },
    sanitizedNavList() {
      return (this.navList || []).filter(item => {
        return !this.productNavId || item.parentId !== this.productNavId
      })
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.currentPath = to.path
        this.closeMenu()
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    window.addEventListener('keydown', this.handleMenuKeydown)
    this.setupDesktopBreakpointListener()
    this.$store.dispatch('button/fetchButtonList', 'nav')
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('keydown', this.handleMenuKeydown)
    this.removeDesktopBreakpointListener()
    this.syncBodyScrollLock(false)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.pageYOffset > 40
    },
    isActive(path) {
      if (!path) return false
      if (path === '/') return this.currentPath === '/'
      return this.currentPath.startsWith(path)
    },
    isDropdownActive(item) {
      const children = this.navChildren(item.id)
      return children.some(child => this.isActive(child.url))
    },
    toggleMenu() {
      if (this.mobileMenuOpen) {
        this.closeMenu()
        return
      }

      this.mobileMenuReturnFocus = document.activeElement
      this.mobileMenuOpen = true
      this.syncBodyScrollLock(true)
      this.$nextTick(() => {
        const firstFocusable = this.getMobileMenuFocusables()[0]
        if (firstFocusable) firstFocusable.focus()
      })
    },
    closeMenu() {
      const shouldRestoreFocus = this.mobileMenuOpen
      this.mobileMenuOpen = false
      this.syncBodyScrollLock(false)
      if (shouldRestoreFocus) {
        this.$nextTick(() => {
          const returnTarget = this.mobileMenuReturnFocus || this.$refs.menuButton
          if (returnTarget && typeof returnTarget.focus === 'function') returnTarget.focus()
          this.mobileMenuReturnFocus = null
        })
      }
    },
    syncBodyScrollLock(locked) {
      document.body.style.overflow = locked ? 'hidden' : ''
    },
    setupDesktopBreakpointListener() {
      if (typeof window.matchMedia !== 'function') return
      this.desktopMediaQuery = window.matchMedia('(min-width: 1200px)')
      if (this.desktopMediaQuery.addEventListener) {
        this.desktopMediaQuery.addEventListener('change', this.handleDesktopBreakpointChange)
      } else if (this.desktopMediaQuery.addListener) {
        this.desktopMediaQuery.addListener(this.handleDesktopBreakpointChange)
      }
    },
    removeDesktopBreakpointListener() {
      if (!this.desktopMediaQuery) return
      if (this.desktopMediaQuery.removeEventListener) {
        this.desktopMediaQuery.removeEventListener('change', this.handleDesktopBreakpointChange)
      } else if (this.desktopMediaQuery.removeListener) {
        this.desktopMediaQuery.removeListener(this.handleDesktopBreakpointChange)
      }
      this.desktopMediaQuery = null
    },
    handleDesktopBreakpointChange(event) {
      if (event.matches) this.closeMenu()
    },
    getMobileMenuFocusables() {
      const menuLinks = this.$refs.mobileNav
        ? Array.from(this.$refs.mobileNav.querySelectorAll(FOCUSABLE_SELECTOR))
        : []
      return this.$refs.menuButton ? [this.$refs.menuButton, ...menuLinks] : menuLinks
    },
    handleMenuKeydown(event) {
      if (!this.mobileMenuOpen) return
      if (event.key === 'Escape') {
        event.preventDefault()
        this.closeMenu()
        return
      }
      if (event.key !== 'Tab') return

      const focusables = this.getMobileMenuFocusables()
      if (focusables.length === 0) return
      const first = focusables[0]
      const last = focusables[focusables.length - 1]
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first.focus()
      }
    },
    toggleDesktopDropdown() {
      this.desktopDropdownOpen = !this.desktopDropdownOpen
    },
    closeDesktopDropdown() {
      this.desktopDropdownOpen = false
    },
    handleDesktopFocusout(event) {
      if (!event.currentTarget.contains(event.relatedTarget)) this.closeDesktopDropdown()
    }
  }
}
</script>

<style lang="scss" scoped>
// ============================================
// Header — Glass Morphism + Editorial Luxury
// ============================================

$header-transition: 0.4s cubic-bezier(0.16, 1, 0.3, 1);
$header-height-wide: 92px;
$header-height-scrolled: 80px;

.site-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: $z-index-header;
  height: $header-height-wide;
  transition: height $header-transition, background-color $header-transition, box-shadow $header-transition, backdrop-filter $header-transition;

  // Top of page — floating, transparent
  &.is-top {
    background-color: rgba(255, 255, 255, 0.92);
    backdrop-filter: saturate(180%) blur(14px);
    -webkit-backdrop-filter: saturate(180%) blur(14px);
    box-shadow: 0 10px 28px rgba(38, 46, 58, 0.055);

    .nav-link {
      color: $color-text;
      text-shadow: none;
    }

    .hamburger span {
      background-color: $color-text;
    }
  }

  // Scrolled — frosted glass
  &.is-scrolled {
    height: $header-height-scrolled;
    background-color: rgba(255, 255, 255, 0.82);
    backdrop-filter: saturate(180%) blur(20px);
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    box-shadow: 0 8px 26px rgba(38, 46, 58, 0.08);

    .nav-link {
      color: $color-text;
    }

    .hamburger span {
      background-color: $color-text;
    }
  }

  // Menu open override — always opaque
  &.menu-open {
    background-color: rgba(255, 255, 255, 0.98);
    backdrop-filter: saturate(180%) blur(20px);
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    box-shadow: none;

    .hamburger span { background-color: $color-text; }
    .nav-link { color: $color-text; }
  }

  @include mobile-only {
    height: $header-height-mobile;

    &.is-scrolled {
      height: 64px;
    }
  }
}

.header-container {
  @include flex-between;
  height: $header-height-wide;
  min-height: $header-height-wide;
  gap: $spacing-xl;

  .is-scrolled & {
    height: $header-height-scrolled;
    min-height: $header-height-scrolled;
  }

  @include mobile-only {
    height: $header-height-mobile;
    min-height: $header-height-mobile;
    gap: $spacing-md;

    .is-scrolled & {
      height: 64px;
      min-height: 64px;
    }
  }
}

// ========== Logo ==========
.logo {
  display: flex;
  align-items: center;
  z-index: $z-index-header + 1;
  text-decoration: none;
  flex-shrink: 0;
}

.logo-image {
  width: 126px;
  height: 78px;
  object-fit: contain;
  transition: width $header-transition, height $header-transition;

  .is-scrolled & {
    width: 108px;
    height: 68px;
  }

  @include mobile-only {
    width: 74px;
    height: 46px;
  }
}

// ========== Desktop Navigation ==========
.nav-menu {
  display: flex;
  align-items: center;
  height: 100%;

  @include tablet-only { display: none; }
  @include mobile-only { display: none; }
}

.nav-list {
  display: flex;
  align-items: center;
  height: 100%;
  gap: $spacing-sm;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
}

.nav-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: $touch-target-min;
  padding: 0 18px;
  font-size: $font-size-base;
  font-weight: $font-weight-semibold;
  color: $color-text;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  border: 0;
  background: transparent;
  font-family: inherit;
  border-radius: $radius-full;
  transition: color 0.3s ease, background-color 0.3s ease;
  letter-spacing: 0;

  // Active pill background
  .nav-item.active > & {
    color: $color-primary;
    background-color: rgba($color-primary, 0.07);
  }

  &:hover {
    color: $color-primary;
    background-color: rgba($color-primary, 0.05);
  }

  // Router link active states
  &.router-link-exact-active,
  &.router-link-active {
    color: $color-primary;
    background-color: rgba($color-primary, 0.07);
  }
}

// ========== Dropdown ==========
.nav-dropdown {
  .nav-link-dropdown {
    .dropdown-arrow {
      transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
      opacity: 0.5;
    }
  }

  &:hover,
  &:focus-within,
  &.is-open {
    .dropdown-arrow {
      transform: rotate(180deg);
      opacity: 1;
    }

    .dropdown-wrapper {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
    }

    .dropdown-menu {
      transform: translateY(0);
      opacity: 1;
    }
  }

  &.active > .nav-link-dropdown {
    color: $color-primary;
    background-color: rgba($color-primary, 0.07);
  }
}

.dropdown-wrapper {
  position: absolute;
  top: calc(100% - 2px);
  left: 50%;
  transform: translateX(-50%);
  padding-top: 8px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.dropdown-menu {
  position: relative;
  background-color: rgba(255, 255, 255, 0.96);
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  border: 1px solid rgba(139, 115, 85, 0.08);
  border-radius: $radius-lg;
  box-shadow:
    0 4px 6px rgba(0, 0, 0, 0.02),
    0 12px 32px rgba(139, 115, 85, 0.1),
    0 0 0 0.5px rgba(139, 115, 85, 0.06);
  min-width: 180px;
  padding: 6px;
  transform: translateY(4px);
  opacity: 0;
  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.25s ease;
  list-style: none;
  margin: 0;

  li {
    padding: 0;
    border-radius: 8px;
    overflow: hidden;

    &.active .dropdown-link {
      color: $color-primary;
      background-color: rgba($color-primary, 0.06);
    }
  }
}

.dropdown-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 20px;
  font-size: 16px;
  font-weight: $font-weight-semibold;
  color: $color-text;
  text-decoration: none;
  transition: all 0.2s ease;
  white-space: nowrap;
  border-radius: 6px;

  &:hover {
    color: $color-primary;
    background-color: rgba($color-primary, 0.05);
  }
}

.dropdown-dot {
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: $color-secondary;
  flex-shrink: 0;
  opacity: 0;
  transform: scale(0);
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);

  .dropdown-link:hover &,
  li.active & {
    opacity: 1;
    transform: scale(1);
  }
}

// ========== Hamburger ==========
.hamburger {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: $touch-target-min;
  height: $touch-target-min;
  padding: 0;
  margin: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  gap: 5px;
  -webkit-tap-highlight-color: transparent;
  -webkit-appearance: none;
  appearance: none;
  outline: none;
  z-index: $z-index-header + 3;

  @include tablet-only { display: flex; }
  @include mobile-only { display: flex; }

  span {
    display: block;
    width: 22px;
    height: 2px;
    background-color: $color-text;
    border-radius: 2px;
    transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
    transform-origin: center;
    pointer-events: none;
  }

  &.open {
    span:nth-child(1) {
      transform: translateY(7px) rotate(45deg);
    }
    span:nth-child(2) {
      opacity: 0;
      transform: scaleX(0);
    }
    span:nth-child(3) {
      transform: translateY(-7px) rotate(-45deg);
    }
  }
}

// ========== Overlay ==========
.menu-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: $z-index-header + 1;
  animation: overlay-in 0.35s ease both;
}

@keyframes overlay-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

// ========== Mobile Drawer ==========
.mobile-nav {
  position: fixed;
  inset: 0;
  min-height: 100vh;
  min-height: 100dvh;
  background-color: rgba(255, 255, 255, 0.98);
  backdrop-filter: saturate(180%) blur(30px);
  -webkit-backdrop-filter: saturate(180%) blur(30px);
  z-index: $z-index-header + 2;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  animation: drawer-in 0.4s cubic-bezier(0.16, 1, 0.3, 1) both;
}

@keyframes drawer-in {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.mobile-nav-inner {
  min-height: 100vh;
  min-height: 100dvh;
  padding: calc(#{$header-height-mobile} + 36px) 20px 48px;

  @include tablet-only {
    padding: calc(#{$header-height} + 40px) 32px 56px;
  }
}

.mobile-nav-list {
  list-style: none;
  margin: 0;
  padding: 0;

  > li:not(.mobile-section-label):not(.sub-item) {
    border-bottom: 1px solid rgba(139, 115, 85, 0.06);

    > a {
      display: block;
      min-height: $touch-target-min;
      padding: 16px 0;
      font-size: 18px;
      font-weight: $font-weight-semibold;
      color: $color-text;
      text-decoration: none;
      transition: color 0.2s ease, padding-left 0.3s ease;
      letter-spacing: 0.3px;

      &:hover,
      &:active {
        color: $color-primary;
        padding-left: 4px;
      }
    }

    &.active > a {
      color: $color-primary;
    }
  }

  .mobile-section-label {
    border-bottom: none;
    padding-top: 8px;

    &:first-child {
      padding-top: 0;
    }
  }

  .mobile-sub-title {
    display: block;
    padding: 20px 0 8px;
    font-size: 12px;
    font-weight: $font-weight-semibold;
    color: $color-text-light;
    text-transform: uppercase;
    letter-spacing: 2.5px;
    border-bottom: 1px solid rgba(139, 115, 85, 0.08);
  }

  .sub-item {
    border-bottom: none;

    a {
      display: block;
      min-height: $touch-target-min;
      padding: 10px 0 10px 16px;
      font-size: 16px;
      font-weight: $font-weight-medium;
      color: $color-text-secondary;
      text-decoration: none;
      transition: color 0.2s ease, padding-left 0.3s ease;
      border-left: 2px solid transparent;

      &:hover,
      &:active {
        color: $color-primary;
        padding-left: 20px;
        border-left-color: rgba($color-primary, 0.2);
      }
    }

    &.active a {
      color: $color-primary;
      border-left-color: $color-primary;
    }
  }
}
</style>
